import React from 'react';
import { createRoot } from 'react-dom/client';
import ConfirmModal from '../components/ConfirmModal';

export function showConfirm(message, title = 'Confirmation', options = {}) {
  return new Promise((resolve) => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const root = createRoot(div);

    const cleanup = (result) => {
      root.unmount();
      document.body.removeChild(div);
      resolve(result);
    };

    root.render(
      <ConfirmModal
        open={true}
        title={title}
        message={message}
        confirmText={options.confirmText}
        cancelText={options.cancelText}
        variant={options.variant}
        onConfirm={() => cleanup(true)}
        onCancel={() => cleanup(false)}
      />
    );
  });
}

export function showPrompt(message, defaultValue = '', title = 'Saisie requise') {
  return new Promise((resolve) => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const root = createRoot(div);

    const cleanup = (result) => {
      root.unmount();
      document.body.removeChild(div);
      resolve(result);
    };

    const PromptModal = () => {
      const [value, setValue] = React.useState(defaultValue);
      const inputRef = React.useRef(null);

      React.useEffect(() => {
        setTimeout(() => inputRef.current?.focus(), 100);
      }, []);

      const handleKeyDown = (e) => {
        if (e.key === 'Enter') cleanup(value);
        if (e.key === 'Escape') cleanup(null);
      };

      return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => cleanup(null)}>
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
            <h3 className="text-lg font-semibold mb-2">{title}</h3>
            <p className="text-gray-600 mb-4">{message}</p>
            <input
              ref={inputRef}
              type="text"
              value={value}
              onChange={e => setValue(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-4"
            />
            <div className="flex justify-end gap-3">
              <button onClick={() => cleanup(null)} className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">Annuler</button>
              <button onClick={() => cleanup(value)} className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors">OK</button>
            </div>
          </div>
        </div>
      );
    };

    root.render(<PromptModal />);
  });
}
